import { CoreConfig } from '@core/types';

// ════════════════════════════════════════════════════════════════════════════
//  CẤU HÌNH RIÊNG CHO DỰ ÁN CON: smartcity-remote (cổng 4203)
// ════════════════════════════════════════════════════════════════════════════

// prettier-ignore
export const coreConfig: CoreConfig = {
  app: {
    appName     : 'SmartCity',
    appTitle    : 'Giám sát Đô thị Thông minh',
    appLogoImage: 'assets/images/logo/logo.jpg',
    appLanguage : 'vi',
  },
  layout: {
    skin  : 'default',
    type  : 'vertical',
    animation : 'fadeIn',
    menu : {
      hidden               : false,
      collapsed            : false,
    },
    navbar: {
      hidden               : false,
      type                 : 'fixed-top',
      background           : 'navbar-light',
      customBackgroundColor: true,
      backgroundColor      : ''
    },
    footer: {
      hidden               : true,
      type                 : 'footer-sticky',
      background           : 'footer-light',
      customBackgroundColor: false,
      backgroundColor      : ''
    },
    enableLocalStorage: false,
    customizer  : true,
    scrollTop   : true,
    buyNow      : false
  }
};
